import React from "react";
import { NewAccordion } from "../NewAccordion";
import { useTranslation } from "react-i18next";
import {
  HowToEnjoy_Heading,
  HowToEnjoy_Step1_Title,
  HowToEnjoy_Step1_Desc,
  HowToEnjoy_Step2_Title,
  HowToEnjoy_Step2_Desc,
  HowToEnjoy_Step3_Title,
  HowToEnjoy_Step3_Desc,
  HowToEnjoy_Alt,
} from "../../../Constants";

const SachetIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="3" width="12" height="18" rx="2.5" stroke="#116D6E" strokeWidth="1.8" fill="#116D6E" fillOpacity="0.08"/>
    <line x1="10" y1="8" x2="22" y2="8" stroke="#116D6E" strokeWidth="1.4"/>
    <circle cx="13" cy="25" r="1.2" fill="#116D6E" opacity="0.5"/>
    <circle cx="16" cy="27.5" r="1.2" fill="#116D6E" opacity="0.7"/>
    <circle cx="19" cy="25" r="1.2" fill="#116D6E" opacity="0.5"/>
    <path d="M16 21 L13 25" stroke="#116D6E" strokeWidth="1.2" strokeLinecap="round" opacity="0.4"/>
    <path d="M16 21 L16 27.5" stroke="#116D6E" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
    <path d="M16 21 L19 25" stroke="#116D6E" strokeWidth="1.2" strokeLinecap="round" opacity="0.4"/>
  </svg>
);

const WaterIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 8h14l-2 18H11L9 8Z" stroke="#116D6E" strokeWidth="1.8" fill="#116D6E" fillOpacity="0.08" strokeLinejoin="round"/>
    <path d="M9 8h14" stroke="#116D6E" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M10.5 14h11" stroke="#116D6E" strokeWidth="1.2" strokeLinecap="round" opacity="0.35"/>
    <path d="M11 18.5c2.5-1.5 5.5-1.5 8 0" stroke="#116D6E" strokeWidth="1.4" strokeLinecap="round" opacity="0.6"/>
    <path d="M22 13c1.5 0 3-1 3-2.5" stroke="#116D6E" strokeWidth="1.4" strokeLinecap="round" opacity="0.5"/>
    <circle cx="25" cy="10" r="1.2" fill="#116D6E" opacity="0.5"/>
  </svg>
);

const CheckIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="12" stroke="#116D6E" strokeWidth="1.8" fill="#116D6E" fillOpacity="0.08"/>
    <path d="M10.5 16.5L14 20L21.5 12" stroke="#116D6E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const STEPS = [
  { Icon: SachetIcon, titleKey: HowToEnjoy_Step1_Title, descKey: HowToEnjoy_Step1_Desc },
  { Icon: WaterIcon, titleKey: HowToEnjoy_Step2_Title, descKey: HowToEnjoy_Step2_Desc },
  { Icon: CheckIcon, titleKey: HowToEnjoy_Step3_Title, descKey: HowToEnjoy_Step3_Desc },
];

const HowToEnjoyAccordion = () => {
  const { t } = useTranslation();
  return (
    <NewAccordion heading={t(HowToEnjoy_Heading)} borderBottom={false}>
      <div className="t-flex t-flex-col t-gap-4 t-pb-3 t-pt-1">
        {STEPS.map(({ Icon, titleKey, descKey }, i) => (
          <div key={i} className="t-flex t-items-start t-gap-3">
            <div className="t-flex-none t-w-8 t-h-8 t-flex t-items-center t-justify-center">
              <Icon />
            </div>
            <div className="t-flex t-flex-col t-gap-0.5">
              <p className="t-m-0 t-font-bold t-text-sm t-text-navy">
                <span className="t-text-quiz-teal t-font-bold">{i + 1}.&nbsp;</span>
                {t(titleKey)}
              </p>
              <p className="t-m-0 t-text-xs t-text-navy/60 t-leading-relaxed">{t(descKey)}</p>
            </div>
          </div>
        ))}
        <div className="t-mt-1 t-rounded-lg t-bg-[#F6E14720] t-border t-border-[#F6E14760] t-px-3 t-py-2.5">
          <p className="t-m-0 t-text-xs t-text-navy/70 t-italic t-leading-relaxed">
            {t(HowToEnjoy_Alt)}
          </p>
        </div>
      </div>
    </NewAccordion>
  );
};

export default HowToEnjoyAccordion;
